<template>
  <div v-if="showForm">
    <div v-if="showPFLoader">
      <Loading instruction="Completing transaction..." />
      <timer
        v-if="canOpenMerchant"
        @time-over="callOpenMerchant"
        class="timer"
        :initialTime="completeTimer"
        :immediate="showPFLoader"
      />
    </div>
    <div v-else>
      <app-header :is-show-info="false"></app-header>
      <div class="success-section-wrapper content-wrapper">
        <div :class="['success-content', computedClasses]">
          <img src="../assets/images/success.svg" alt="success" />
          <h3>Payment successful!</h3>

          <div class="transaction-info">
            <div class="title">Bank:</div>
            <div class="data">
              {{ transaction.acquirerName }}
            </div>

            <div class="title">Reference:</div>
            <div class="data">
              {{ transaction.sellerReference }}
            </div>

            <div class="title">Date:</div>
            <div class="data">
              {{ date }}
            </div>

            <div class="title">Time:</div>
            <div class="data">
              {{ time }}
            </div>

            <div class="title">Amount:</div>
            <div class="data">
              {{ amount }}
            </div>
          </div>

          <success-button
            v-if="canOpenMerchant"
            @click="callOpenMerchant"
            :is-loading="isLoading"
          >
            Done
          </success-button>
          <timer
            v-if="canOpenMerchant"
            @time-over="callOpenMerchant"
            class="timer"
            :initialTime="completeTimer"
            :immediate="false"
          />
        </div>
      </div>
    </div>
    <!-- The hidden form used when we post to the merchants URL -->
    <section style="display: none">
      <form method="post" action="" id="redirectForm" ref="redirectForm">
        <input type="hidden" name="SID_STATUS" value="" />
        <input type="hidden" name="SID_MERCHANT" value="" />
        <input type="hidden" name="SID_COUNTRY" value="" />
        <input type="hidden" name="SID_CURRENCY" value="" />
        <input type="hidden" name="SID_REFERENCE" value="" />
        <input type="hidden" name="SID_AMOUNT" value="" />
        <input type="hidden" name="SID_BANK" value="" />
        <input type="hidden" name="SID_DATE" value="" />
        <input type="hidden" name="SID_RECEIPTNO" value="" />
        <input type="hidden" name="SID_TNXID" value="" />
        <input type="hidden" name="SID_CUSTOM_01" value="" />
        <input type="hidden" name="SID_CUSTOM_02" value="" />
        <input type="hidden" name="SID_CUSTOM_03" value="" />
        <input type="hidden" name="SID_CUSTOM_04" value="" />
        <input type="hidden" name="SID_CUSTOM_05" value="" />
        <input type="hidden" name="SID_CONSISTENT" value="" />
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { format } from 'date-fns'
import Header from '@/components/Header'
import Timer from '@/components/Timer'
import SuccessButton from '@/components/buttons/SuccessButton'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'
import { redirect } from '@/mixins/redirect'
import Loading from '@/components/Loading'

export default {
  name: 'TransactionCompleted',
  components: { 'app-header': Header, Timer, SuccessButton, Loading },
  mixins: [blockBackNavigationMixin, redirect],

  data() {
    return {
      isLoading: false,
      completeTimer: Constants.completeTimer,
    }
  },
  computed: {
    ...mapState('appSettings', ['originalUrl']),
    ...mapState('transaction', ['transaction', 'showBodyOnly', 'hideContent']),
    ...mapState('merchantSettings', ['merchantReturnURL', 'merchantReturn']),
    ...mapGetters('merchantSettings', [
      'canRetryTransaction',
      'canOpenMerchant',
    ]),
    transactionId() {
      return this.$route.query.transactionId
    },
    transactionStatus() {
      return (
        this.transaction &&
        this.transaction.status &&
        this.transaction.status.toUpperCase()
      )
    },
    computedClasses() {
      return {
        'no-shadow': this.showBodyOnly,
      }
    },
    showPFLoader() {
      return this.showBodyOnly && this.merchantReturn
    },
    showForm() {
      return !this.hideContent
    },
    amount() {
      const currency = this.transaction.currency
      if (currency === 'ZAR') {
        return `${currency} ${this.transaction.amount}`
      }

      return `${this.transaction.amount} ${currency}`
    },

    date() {
      return format(new Date(this.transaction.date), 'dd MMMM yyyy')
    },

    time() {
      return format(new Date(this.transaction.date), 'h:mm:ss aa')
    },
  },

  methods: {
    ...mapActions('merchantSettings', ['loadSettings']),
    ...mapActions('transaction', ['getTransaction']),
    async callGetTransaction() {
      try {
        await this.getTransaction({
          transactionId: this.transactionId,
          retries: Constants.maxRetryOnError,
        })
      } catch (error) {
        if (this.transactionId) {
          await this.$logError({
            transactionId: this.transactionId,
            message: 'Redirection error - reload transaction',
            stackTrace: error,
          })
        }
      }
    },

    retryTransaction() {
      window.location = this.originalUrl
    },
  },
}
</script>

<style scoped lang="scss">
.success-section-wrapper {
  padding: 40px 64px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: $mobile-resolution) {
    padding: 32px 16px;
  }
}

.success-content {
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  padding: 24px 60px;
  text-align: center;
  position: relative;
  width: 100%;

  @media screen and (max-width: $mobile-resolution) {
    padding: 24px;
  }

  h3 {
    margin: 0;
    padding: 16px 0 24px 0;
    font-size: 18px;
  }

  .btn {
    margin: auto;
  }

  .transaction-info {
    width: 100%;
    margin: 16px auto 20px auto;
    padding: 0 76px;
    font-size: 14px;
    line-height: 17px;
    text-align: right;

    @media screen and (max-width: $mobile-resolution) {
      margin: 0;
      padding: 0;
    }

    div {
      padding: 0 0 16px 0;
      width: 50%;
      float: left;
    }

    .title {
      font-weight: bold;
      text-align: left;
    }
  }

  .timer {
    padding: 30px 0 0 0;
  }
}
</style>
